import React, { Component, useEffect, useState, useRef } from "react";
import relaxvideo from "../media/relax.mp4";
import axios from "axios";
import RunCustomAppCard from "../components/RunCustomAppCard";
const user_name = localStorage.getItem("user_name");

function MiniApp() {
 
  const [appName, setAppName] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const [version, setVersion] = useState('1.0.0');
  const [parameters, setParameters] = useState([{ name: '', type: 'str' }]);
  const [code, setCode] = useState('');

  const handleParamChange = (index, field, value) => {
    const updatedParams = [...parameters];
    updatedParams[index][field] = value;
    setParameters(updatedParams);
  };

  const addParameter = () => {
    setParameters([...parameters, { name: '', type: 'str' }]);
  };

  const removeParameter = (index) => {
    const updatedParams = parameters.filter((_, i) => i !== index);
    setParameters(updatedParams);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      app_name: appName,
      description,
      category,
      version,
      parameters,
      code,
    };

    try {
      const response = await axios.post(
        '/To_Save_Custom_App',
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`, // replace with your JWT source
            'Content-Type': 'application/json',
          },
        }
      );
      alert('App saved successfully!');
      console.log(response.data);
    } catch (err) {
      console.error('Error saving app:', err);
      alert('Failed to save app.');
    }
  };

  return (
   <>
   <div className="container"><div className="row mt-5 gx-4 px-4">
  {/* Left: App Creator */}
  <div className="col-lg-6 mb-5">
    <div className="card border-0 shadow-lg rounded-4 h-100">
      <div className="card-header bg-dark text-white rounded-top-4 py-3 px-4">
        <h4 className="mb-0 d-flex align-items-center">
          🛠️ <span className="ms-2">Create Custom App</span>
        </h4>
      </div>
      <div className="card-body p-4">
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">App Name</label>
            <input
              type="text"
              className="form-control form-control-lg"
              value={appName}
              onChange={(e) => setAppName(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Description</label>
            <textarea
              className="form-control"
              rows={2}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Explain what this app does..."
            />
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label fw-semibold">Category</label>
              <input
                type="text"
                className="form-control"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label fw-semibold">Version</label>
              <input
                type="text"
                className="form-control"
                value={version}
                onChange={(e) => setVersion(e.target.value)}
              />
            </div>
          </div>

          {/* Parameters Section */}
          <div className="mb-4">
            <h5 className="fw-bold mb-3">🧾 Parameters</h5>
            {parameters.map((param, index) => (
              <div className="d-flex align-items-center mb-2 gap-2" key={index}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Parameter name"
                  value={param.name}
                  onChange={(e) => handleParamChange(index, 'name', e.target.value)}
                  required
                />
                <select
                  className="form-select"
                  value={param.type}
                  onChange={(e) => handleParamChange(index, 'type', e.target.value)}
                >
                  <option value="str">str</option>
                  <option value="int">int</option>
                  <option value="float">float</option>
                  <option value="bool">bool</option>
                </select>
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={() => removeParameter(index)}
                >
                  &times;
                </button>
              </div>
            ))}
            <button
              type="button"
              className="btn btn-sm btn-outline-primary mt-2"
              onClick={addParameter}
            >
              + Add Parameter
            </button>
          </div>

          {/* Code Block */}
          <div className="mb-4">
            <label className="form-label fw-semibold">Python Code</label>
            <textarea
              className="form-control font-monospace"
              style={{
                backgroundColor: "#f7f9fa",
                fontSize: "0.95rem",
                border: "1px solid #dee2e6",
              }}
              rows={7}
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder={`def run(params):\n    return {"result": "your logic here"}`}
              required
            />
            <small className="text-muted">
              Define a <code>run(params)</code> function that returns a response.
            </small>
          </div>

          <div className="d-grid">
            <button type="submit" className="btn btn-success btn-lg">
              💾 Save App
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  {/* Right: App Runner */}
  <div className="col-lg-6 mb-5">
    <RunCustomAppCard />
  </div>
</div></div>
  
</>
  );
};

export default MiniApp;
